import { render, staticRenderFns } from "./DocumentsLegaux.vue?vue&type=template&id=d1feea0c"
import script from "./DocumentsLegaux.vue?vue&type=script&lang=js"
export * from "./DocumentsLegaux.vue?vue&type=script&lang=js"
import style0 from "./DocumentsLegaux.vue?vue&type=style&index=0&id=d1feea0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports